import Lightbox from 'lightbox2/dist/js/lightbox-plus-jquery';

Lightbox.option({
  'disableScrolling': true,
  'wrapAround': true
});
